<!--  BEGIN CONTENT PART  -->
<div id="content" class="main-content">
    <div class="container">
        <div class="page-header ">
            <div class="page-title col-lg-12 col-md-12 col-sm-12 col-xs-12 justify-content-between ">
                <h2 class="col-sm-12 col-xs-12">
                    <i class="fa fa-address-card-o"></i> <b> Liste des contacts</b>
                </h2>
            </div>
        </div>
        <div>
            <div class="row"  style="justify-content: end;">
                <div>
                    <a type="button" class="btn btn-gradient-dark ml-2 mb-2 btn-rounded btn_new_customer" 
                        href="/new-contact" >
                        <i class="flaticon-plus-1 mr-2"></i> Nouveau contact
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col col-lg-12">
                    <div class="row" id="cancel-row" >
                        <div class="col-xl-12 col-lg-12 pr-0 pl-0 layout-spacing">
                            <div class="statbox widget box box-shadow">
                                <div class="widget-header">
                                    <div class="row">       
                                    </div>
                                </div>
                                <div class="widget-content widget-content-area pl-0 pr-1">
                                    <div *ngIf="contactLoading" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                                    margin-bottom: 15%;"></div>
                                    <div class="table-responsive mb-4" *ngIf="!contactLoading">
                                        <table id="alter_pagination" class="table table-striped table-bordered table-hover" style="width:100%">
                                            <thead>
                                              <tr>
                                                <th>Nom complet</th>
                                                <th>Nom du compte</th>
                                                <th>Site du compte</th>
                                                <th>Téléphone</th>
                                                <th>Adresse email</th>
                                                <th>Propriétaire</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr *ngFor="let contact of allContact">
                                                <td>
                                                    <a [attr.href]="'contact/'+contact?.uuid" class="mr-2 action_plan_unique fullName">
                                                        <!-- <span *ngIf="contact.civility == 'Mr'"> Mr.</span>
                                                        <span *ngIf="contact.civility == 'Mme' || contact.civility == 'Mlle'"> Ms.</span> -->
                                                        {{ contact.fullName }}
                                                    </a>
                                                </td>
                                                <td *ngIf="contact.customerUuid == null">
                                                    <span *ngIf="contact.accountName != null">{{ contact.accountName }}</span>
                                                    <span *ngIf="contact.accountName == null || contact.accountName == ''">----</span>
                                                </td>
                                                <td *ngIf="contact.customerUuid != null">
                                                    <a [attr.href]="'/customer/fromshow;cs='+contact?.customerUuid" class="mr-2 action_plan_unique accountName">
                                                        {{ contact.accountName }}
                                                    </a>
                                                </td>
                                                <td>
                                                    <span *ngIf="contact.accountSite  != null">{{ contact.accountSite  }}</span>
                                                    <span *ngIf="contact.accountSite  == null || contact.accountSite  == ''">----</span>
                                                </td>
                                                <td class="tel" (click)="sendMessageWhatsapp(contact.tel)">
                                                    <i class="fa fa-whatsapp"></i>  {{ contact.tel }}
                                                </td>
                                                <!-- <td><a href="mailto:{{contact.mail}}?subject=MF : Nouvelle connaissance&body=Bonjour,">{{ contact.mail }}</a></td> -->
                                                <td>
                                                    <a class="email" href="https://mail.google.com/mail/?view=cm&fs=1&to={{ contact.mail }}&su=MF%20%3A%20Nouvelle%20connaissance&body=Bonjour," target="_blank">
                                                        <i class="fa fa-envelope"></i> {{ contact.mail }}
                                                    </a>
                                                </td>
                                                <td>
                                                    <span *ngIf="contact.owner != null">{{ contact.owner }}</span>
                                                    <span *ngIf="contact.owner == null || contact.owner == ''">----</span>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>